import React from 'react';
import {
  AdditionalFieldType,
  FieldType,
} from '@teetsh/app/src/types/customField';
import HtmlViewer from '@teetsh/app/src/components/HtmlViewer';
import { Tag } from '@teetsh/app/src/components/Tag';
import { format } from '@teetsh/app/src/utils/time/format';
import { frenchDatePatternWithSlashes } from 'utils/time/datePatterns';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { useTranslation } from 'react-i18next';

interface Props {
  fieldType: FieldType | AdditionalFieldType;
  value: any;
  options?: any;
}

export function CustomFieldDisplayer(props: Props) {
  const { value, fieldType } = props;
  const { locale } = useUser();
  const { t } = useTranslation(['common']);

  switch (fieldType) {
    case 'text':
      return (
        <div>
          <HtmlViewer onChange={() => {}} text={value} />
        </div>
      );
    case 'richtext':
      return (
        <div>
          <HtmlViewer onChange={() => {}} text={value} />
        </div>
      );
    case 'bool':
      return (
        <div>{value ? t('common:values.yes') : t('common:values.no')}</div>
      );
    case 'date':
      return <div>{format(value, locale, frenchDatePatternWithSlashes)}</div>;
    case 'number':
      return <div>{value}</div>;
    case 'phone':
      return <div>{value}</div>;
    case 'select':
    case 'multiselect':
      // eslint-disable-next-line no-case-declarations
      const matchingOption = (props?.options || []).find(
        (opt: any) => opt.id === value,
      );
      return (
        <div>
          <Tag color={matchingOption?.color || 'gris-moderate'}>
            {matchingOption?.value}
          </Tag>
        </div>
      );
    case 'filesAndMedia':
      return <div>FILES</div>;
    case 'image':
      return <div>IMAGE</div>;
  }
}
